import { render } from "./Sidebar.vue?vue&type=template&id=7e060e0e"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
script.render = render

export default script